<script>
import { mapGetters } from 'vuex';
import request from '@/utils/request';
import PaginatedList from '@/views/components/PaginatedList';
import BundlesHeader from './components/BundlesHeader';
import Bundle from './components/Bundle';

export default {
  components: {
    BundlesHeader,
    Bundle,
  },
  extends: PaginatedList,
  computed: {
    ...mapGetters({
      items: 'bundles/list/getData',
      paginationParams: 'bundles/list/getPaginationParams',
      isLoadingBundles: 'bundles/list/getIsLoading',
      isLoaded: 'bundles/list/getIsLoaded',
    }),
  },
  methods: {
    async closeModal(response) {
      try {
        this.isOpen = !this.isOpen;

        if (response) {
          await request.delete(`/bundles/${this.selectedItem.uuid}`);

          await this.navigate({
            timestamp: new Date().getTime(),
          });

          this.$notify({
            type: 'success',
            title: 'Επιτυχία',
            text: 'Το Bundle διαγράφτηκε επιτυχώς!!',
          });
        }
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'To αίτημα απέτυχε',
        });
      }
    },
  },
};
</script>
